export default __webpack_public_path__ + "static/media/microwaveadd.6739da57.png";